export default __webpack_public_path__ + "static/media/pills@2x.b0a76faf.png";